__turbopack_context__.v({
  "actions": "optimizedTileImage-module-scss-module__z4JJlW__actions",
  "container": "optimizedTileImage-module-scss-module__z4JJlW__container",
  "image": "optimizedTileImage-module-scss-module__z4JJlW__image",
  "overlay": "optimizedTileImage-module-scss-module__z4JJlW__overlay",
  "placeholder": "optimizedTileImage-module-scss-module__z4JJlW__placeholder",
  "placeholderIcon": "optimizedTileImage-module-scss-module__z4JJlW__placeholderIcon",
  "playIcon": "optimizedTileImage-module-scss-module__z4JJlW__playIcon",
  "videoFallback": "optimizedTileImage-module-scss-module__z4JJlW__videoFallback",
});
